// Нативный браузерный декодер штрихкодов (Chrome Android, Edge).
// На iOS Safari не поддерживается. Используется как быстрый путь,
// html5-qrcode остаётся как fallback.

interface DetectedBarcode {
  rawValue: string;
  format: string;
}

interface BarcodeDetectorInstance {
  detect(source: CanvasImageSource): Promise<DetectedBarcode[]>;
}

interface BarcodeDetectorConstructor {
  new (opts: { formats: string[] }): BarcodeDetectorInstance;
  getSupportedFormats(): Promise<string[]>;
}

declare global {
  interface Window {
    BarcodeDetector?: BarcodeDetectorConstructor;
  }
}

export async function isBarcodeDetectorSupported(): Promise<boolean> {
  if (typeof window === 'undefined' || !window.BarcodeDetector) return false;
  try {
    const formats = await window.BarcodeDetector.getSupportedFormats();
    return formats.includes('data_matrix');
  } catch {
    return false;
  }
}

export function createDataMatrixDetector(): BarcodeDetectorInstance {
  if (!window.BarcodeDetector) {
    throw new Error('BarcodeDetector not supported in this browser');
  }
  return new window.BarcodeDetector({ formats: ['data_matrix'] });
}
